/**
 * 접힘 전용 상단 nav — 사이드바가 접혔을 때 헤더에 노출.
 * ★2026-07-13(사용자 요청): 상단은 검색바(로고 옆)가 주역 → nav 는 **가장 자주 쓰는
 *   AI HS 분류 1개만** 남긴다(나머지 메뉴는 왼쪽 사이드바 담당). 원천=MENU_ITEMS(하드코딩 금지).
 * SPA 이동(pushState + popstate) — Sidebar 메뉴 클릭과 동일 규약.
 * 설계: docs/superpowers/specs/2026-07-12-top-header-restructure-design.md
 */
import { MENU_ITEMS } from "../config/menuConfig";

// 자주 쓰는 AI HS 분류만(그 외 상단 노출 제거 — 사이드바가 메뉴 담당).
const CORE = MENU_ITEMS.filter((m) => m.id === "hs-ai-classify");

function auditOf(href) {
  try {
    return new URL(href, "https://x").searchParams.get("audit");
  } catch {
    return null;
  }
}

export default function CollapsedSidebarTopNav() {
  const current =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("audit")
      : null;

  const go = (item) => {
    if (item.spa) {
      window.history.pushState({}, "", item.href);
      window.dispatchEvent(new PopStateEvent("popstate"));
    } else {
      window.location.href = item.href;
    }
  };

  return (
    <nav className="flex items-center" style={{ gap: 2 }}>
      {CORE.map((item) => {
        const active = current && auditOf(item.href) === current;
        return (
          <button
            key={item.id}
            onClick={() => go(item)}
            title={item.label}
            style={{
              border: "none",
              background: active ? "var(--audit-bg-subtle, #f1f3f4)" : "transparent",
              color: active
                ? "var(--audit-text, #141413)"
                : "var(--audit-text-muted, #5f6368)",
              fontWeight: active ? 700 : 500,
              fontSize: 13,
              fontFamily: "inherit",
              padding: "6px 10px",
              borderRadius: 8,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            {item.shortLabel || item.label}
          </button>
        );
      })}
    </nav>
  );
}
